import { jsx as s } from "react/jsx-runtime";
import * as a from "react";
import { c as fe, a as v, u as cn } from "../../index-DcwNtM_b.js";
import { u as L, c as sn, b as me } from "../../index-5Bhkapwi.js";
import { P as y, d as un } from "../../index-CpDnqHCm.js";
import { c as dn, u as ln } from "../../index-TA5H0I__.js";
import { P as pn, D as fn } from "../../index-C1kx85Np.js";
import { h as mn, u as Mn, R as vn, F as gn } from "../../Combination-CmNnuUVg.js";
import { c as Me, C as wn, R as hn, A as _n, a as Cn } from "../../index-Bebf-Vfp.js";
import { P as X } from "../../index-DBEov9sD.js";
import { c as ve, I as Rn, R as Dn } from "../../index-BJirOIk2.js";
import { u as ge } from "../../index-0ioNhtNM.js";
import { u as le } from "../../index-CDznMoQN.js";
import { c as we } from "../../utils-BOFVZgHd.js";
var J = ["Enter", " "], Pn = ["ArrowDown", "PageUp", "Home"], he = ["ArrowUp", "PageDown", "End"], En = [...Pn, ...he], In = {
  ltr: [...J, "ArrowRight"],
  rtl: [...J, "ArrowLeft"]
}, bn = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, F = "Menu", [O, Sn, yn] = dn(F), [D, _e] = fe(F, [
  yn,
  Me,
  ve
]), Y = Me(), Ce = ve(), [xn, P] = D(F), [Nn, G] = D(F), Re = (e) => {
  const { __scopeMenu: o, open: n = !1, children: t, dir: r, onOpenChange: c, modal: d = !0 } = e, l = Y(o), [m, M] = a.useState(null), p = a.useRef(!1), u = ge(c), f = ln(r);
  return a.useEffect(() => {
    const _ = () => {
      p.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => p.current = !1;
    return document.addEventListener("keydown", _, { capture: !0 }), () => {
      document.removeEventListener("keydown", _, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ s(hn, { ...l, children: /* @__PURE__ */ s(
    xn,
    {
      scope: o,
      open: n,
      onOpenChange: u,
      content: m,
      onContentChange: M,
      children: /* @__PURE__ */ s(
        Nn,
        {
          scope: o,
          onClose: a.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: p,
          dir: f,
          modal: d,
          children: t
        }
      )
    }
  ) });
};
Re.displayName = F;
var An = "MenuAnchor", Q = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e, r = Y(n);
    return /* @__PURE__ */ s(_n, { ...r, ...t, ref: o });
  }
);
Q.displayName = An;
var ee = "MenuPortal", [Tn, De] = D(ee, {
  forceMount: void 0
}), Pe = (e) => {
  const { __scopeMenu: o, forceMount: n, children: t, container: r } = e, c = P(ee, o);
  return /* @__PURE__ */ s(Tn, { scope: o, forceMount: n, children: /* @__PURE__ */ s(X, { present: n || c.open, children: /* @__PURE__ */ s(pn, { asChild: !0, container: r, children: t }) }) });
};
Pe.displayName = ee;
var C = "MenuContent", [On, ne] = D(C), Ee = a.forwardRef(
  (e, o) => {
    const n = De(C, e.__scopeMenu), { forceMount: t = n.forceMount, ...r } = e, c = P(C, e.__scopeMenu), d = G(C, e.__scopeMenu);
    return /* @__PURE__ */ s(O.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ s(X, { present: t || c.open, children: /* @__PURE__ */ s(O.Slot, { scope: e.__scopeMenu, children: d.modal ? /* @__PURE__ */ s(kn, { ...r, ref: o }) : /* @__PURE__ */ s(Ln, { ...r, ref: o }) }) }) });
  }
), kn = a.forwardRef(
  (e, o) => {
    const n = P(C, e.__scopeMenu), t = a.useRef(null), r = L(o, t);
    return a.useEffect(() => {
      const c = t.current;
      if (c) return mn(c);
    }, []), /* @__PURE__ */ s(
      oe,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: v(
          e.onFocusOutside,
          (c) => c.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Ln = a.forwardRef((e, o) => {
  const n = P(C, e.__scopeMenu);
  return /* @__PURE__ */ s(
    oe,
    {
      ...e,
      ref: o,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Fn = sn("MenuContent.ScrollLock"), oe = a.forwardRef(
  (e, o) => {
    const {
      __scopeMenu: n,
      loop: t = !1,
      trapFocus: r,
      onOpenAutoFocus: c,
      onCloseAutoFocus: d,
      disableOutsidePointerEvents: l,
      onEntryFocus: m,
      onEscapeKeyDown: M,
      onPointerDownOutside: p,
      onFocusOutside: u,
      onInteractOutside: f,
      onDismiss: _,
      disableOutsideScroll: g,
      ...E
    } = e, x = P(C, n), I = G(C, n), Je = Y(n), Qe = Ce(n), ce = Sn(n), [en, se] = a.useState(null), K = a.useRef(null), nn = L(o, K, x.onContentChange), U = a.useRef(0), $ = a.useRef(""), on = a.useRef(0), W = a.useRef(null), ue = a.useRef("right"), z = a.useRef(0), tn = g ? vn : a.Fragment, rn = g ? { as: Fn, allowPinchZoom: !0 } : void 0, an = (i) => {
      const S = $.current + i, R = ce().filter((h) => !h.disabled), N = document.activeElement, Z = R.find((h) => h.ref.current === N)?.textValue, q = R.map((h) => h.textValue), ie = zn(q, S, Z), A = R.find((h) => h.textValue === ie)?.ref.current;
      (function h(de) {
        $.current = de, window.clearTimeout(U.current), de !== "" && (U.current = window.setTimeout(() => h(""), 1e3));
      })(S), A && setTimeout(() => A.focus());
    };
    a.useEffect(() => () => window.clearTimeout(U.current), []), Mn();
    const b = a.useCallback((i) => ue.current === W.current?.side && qn(i, W.current?.area), []);
    return /* @__PURE__ */ s(
      On,
      {
        scope: n,
        searchRef: $,
        onItemEnter: a.useCallback(
          (i) => {
            b(i) && i.preventDefault();
          },
          [b]
        ),
        onItemLeave: a.useCallback(
          (i) => {
            b(i) || (K.current?.focus(), se(null));
          },
          [b]
        ),
        onTriggerLeave: a.useCallback(
          (i) => {
            b(i) && i.preventDefault();
          },
          [b]
        ),
        pointerGraceTimerRef: on,
        onPointerGraceIntentChange: a.useCallback((i) => {
          W.current = i;
        }, []),
        children: /* @__PURE__ */ s(tn, { ...rn, children: /* @__PURE__ */ s(
          gn,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: v(c, (i) => {
              i.preventDefault(), K.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: d,
            children: /* @__PURE__ */ s(
              fn,
              {
                asChild: !0,
                disableOutsidePointerEvents: l,
                onEscapeKeyDown: M,
                onPointerDownOutside: p,
                onFocusOutside: u,
                onInteractOutside: f,
                onDismiss: _,
                children: /* @__PURE__ */ s(
                  Dn,
                  {
                    asChild: !0,
                    ...Qe,
                    dir: I.dir,
                    orientation: "vertical",
                    loop: t,
                    currentTabStopId: en,
                    onCurrentTabStopIdChange: se,
                    onEntryFocus: v(m, (i) => {
                      I.isUsingKeyboardRef.current || i.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ s(
                      wn,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": $e(x.open),
                        "data-radix-menu-content": "",
                        dir: I.dir,
                        ...Je,
                        ...E,
                        ref: nn,
                        style: { outline: "none", ...E.style },
                        onKeyDown: v(E.onKeyDown, (i) => {
                          const R = i.target.closest("[data-radix-menu-content]") === i.currentTarget, N = i.ctrlKey || i.altKey || i.metaKey, Z = i.key.length === 1;
                          R && (i.key === "Tab" && i.preventDefault(), !N && Z && an(i.key));
                          const q = K.current;
                          if (i.target !== q || !En.includes(i.key)) return;
                          i.preventDefault();
                          const A = ce().filter((h) => !h.disabled).map((h) => h.ref.current);
                          he.includes(i.key) && A.reverse(), Hn(A);
                        }),
                        onBlur: v(e.onBlur, (i) => {
                          i.currentTarget.contains(i.target) || (window.clearTimeout(U.current), $.current = "");
                        }),
                        onPointerMove: v(
                          e.onPointerMove,
                          k((i) => {
                            const S = i.target, R = z.current !== i.clientX;
                            if (i.currentTarget.contains(S) && R) {
                              const N = i.clientX > z.current ? "right" : "left";
                              ue.current = N, z.current = i.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ee.displayName = C;
var Gn = "MenuGroup", te = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e;
    return /* @__PURE__ */ s(y.div, { role: "group", ...t, ref: o });
  }
);
te.displayName = Gn;
var Kn = "MenuLabel", Ie = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e;
    return /* @__PURE__ */ s(y.div, { ...t, ref: o });
  }
);
Ie.displayName = Kn;
var B = "MenuItem", pe = "menu.itemSelect", j = a.forwardRef(
  (e, o) => {
    const { disabled: n = !1, onSelect: t, ...r } = e, c = a.useRef(null), d = G(B, e.__scopeMenu), l = ne(B, e.__scopeMenu), m = L(o, c), M = a.useRef(!1), p = () => {
      const u = c.current;
      if (!n && u) {
        const f = new CustomEvent(pe, { bubbles: !0, cancelable: !0 });
        u.addEventListener(pe, (_) => t?.(_), { once: !0 }), un(u, f), f.defaultPrevented ? M.current = !1 : d.onClose();
      }
    };
    return /* @__PURE__ */ s(
      be,
      {
        ...r,
        ref: m,
        disabled: n,
        onClick: v(e.onClick, p),
        onPointerDown: (u) => {
          e.onPointerDown?.(u), M.current = !0;
        },
        onPointerUp: v(e.onPointerUp, (u) => {
          M.current || u.currentTarget?.click();
        }),
        onKeyDown: v(e.onKeyDown, (u) => {
          const f = l.searchRef.current !== "";
          n || f && u.key === " " || J.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
j.displayName = B;
var be = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, disabled: t = !1, textValue: r, ...c } = e, d = ne(B, n), l = Ce(n), m = a.useRef(null), M = L(o, m), [p, u] = a.useState(!1), [f, _] = a.useState("");
    return a.useEffect(() => {
      const g = m.current;
      g && _((g.textContent ?? "").trim());
    }, [c.children]), /* @__PURE__ */ s(
      O.ItemSlot,
      {
        scope: n,
        disabled: t,
        textValue: r ?? f,
        children: /* @__PURE__ */ s(Rn, { asChild: !0, ...l, focusable: !t, children: /* @__PURE__ */ s(
          y.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": t || void 0,
            "data-disabled": t ? "" : void 0,
            ...c,
            ref: M,
            onPointerMove: v(
              e.onPointerMove,
              k((g) => {
                t ? d.onItemLeave(g) : (d.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: v(
              e.onPointerLeave,
              k((g) => d.onItemLeave(g))
            ),
            onFocus: v(e.onFocus, () => u(!0)),
            onBlur: v(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), Un = "MenuCheckboxItem", Se = a.forwardRef(
  (e, o) => {
    const { checked: n = !1, onCheckedChange: t, ...r } = e;
    return /* @__PURE__ */ s(Te, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ s(
      j,
      {
        role: "menuitemcheckbox",
        "aria-checked": V(n) ? "mixed" : n,
        ...r,
        ref: o,
        "data-state": ae(n),
        onSelect: v(
          r.onSelect,
          () => t?.(V(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Se.displayName = Un;
var ye = "MenuRadioGroup", [$n, Bn] = D(
  ye,
  { value: void 0, onValueChange: () => {
  } }
), xe = a.forwardRef(
  (e, o) => {
    const { value: n, onValueChange: t, ...r } = e, c = ge(t);
    return /* @__PURE__ */ s($n, { scope: e.__scopeMenu, value: n, onValueChange: c, children: /* @__PURE__ */ s(te, { ...r, ref: o }) });
  }
);
xe.displayName = ye;
var Ne = "MenuRadioItem", Ae = a.forwardRef(
  (e, o) => {
    const { value: n, ...t } = e, r = Bn(Ne, e.__scopeMenu), c = n === r.value;
    return /* @__PURE__ */ s(Te, { scope: e.__scopeMenu, checked: c, children: /* @__PURE__ */ s(
      j,
      {
        role: "menuitemradio",
        "aria-checked": c,
        ...t,
        ref: o,
        "data-state": ae(c),
        onSelect: v(
          t.onSelect,
          () => r.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ae.displayName = Ne;
var re = "MenuItemIndicator", [Te, Vn] = D(
  re,
  { checked: !1 }
), Oe = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, forceMount: t, ...r } = e, c = Vn(re, n);
    return /* @__PURE__ */ s(
      X,
      {
        present: t || V(c.checked) || c.checked === !0,
        children: /* @__PURE__ */ s(
          y.span,
          {
            ...r,
            ref: o,
            "data-state": ae(c.checked)
          }
        )
      }
    );
  }
);
Oe.displayName = re;
var Xn = "MenuSeparator", ke = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e;
    return /* @__PURE__ */ s(
      y.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...t,
        ref: o
      }
    );
  }
);
ke.displayName = Xn;
var Yn = "MenuArrow", Le = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...t } = e, r = Y(n);
    return /* @__PURE__ */ s(Cn, { ...r, ...t, ref: o });
  }
);
Le.displayName = Yn;
var jn = "MenuSub", [ot, Fe] = D(jn), T = "MenuSubTrigger", Ge = a.forwardRef(
  (e, o) => {
    const n = P(T, e.__scopeMenu), t = G(T, e.__scopeMenu), r = Fe(T, e.__scopeMenu), c = ne(T, e.__scopeMenu), d = a.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: m } = c, M = { __scopeMenu: e.__scopeMenu }, p = a.useCallback(() => {
      d.current && window.clearTimeout(d.current), d.current = null;
    }, []);
    return a.useEffect(() => p, [p]), a.useEffect(() => {
      const u = l.current;
      return () => {
        window.clearTimeout(u), m(null);
      };
    }, [l, m]), /* @__PURE__ */ s(Q, { asChild: !0, ...M, children: /* @__PURE__ */ s(
      be,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": $e(n.open),
        ...e,
        ref: me(o, r.onTriggerChange),
        onClick: (u) => {
          e.onClick?.(u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: v(
          e.onPointerMove,
          k((u) => {
            c.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !d.current && (c.onPointerGraceIntentChange(null), d.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: v(
          e.onPointerLeave,
          k((u) => {
            p();
            const f = n.content?.getBoundingClientRect();
            if (f) {
              const _ = n.content?.dataset.side, g = _ === "right", E = g ? -5 : 5, x = f[g ? "left" : "right"], I = f[g ? "right" : "left"];
              c.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + E, y: u.clientY },
                  { x, y: f.top },
                  { x: I, y: f.top },
                  { x: I, y: f.bottom },
                  { x, y: f.bottom }
                ],
                side: _
              }), window.clearTimeout(l.current), l.current = window.setTimeout(
                () => c.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (c.onTriggerLeave(u), u.defaultPrevented) return;
              c.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: v(e.onKeyDown, (u) => {
          const f = c.searchRef.current !== "";
          e.disabled || f && u.key === " " || In[t.dir].includes(u.key) && (n.onOpenChange(!0), n.content?.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
Ge.displayName = T;
var Ke = "MenuSubContent", Ue = a.forwardRef(
  (e, o) => {
    const n = De(C, e.__scopeMenu), { forceMount: t = n.forceMount, ...r } = e, c = P(C, e.__scopeMenu), d = G(C, e.__scopeMenu), l = Fe(Ke, e.__scopeMenu), m = a.useRef(null), M = L(o, m);
    return /* @__PURE__ */ s(O.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ s(X, { present: t || c.open, children: /* @__PURE__ */ s(O.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ s(
      oe,
      {
        id: l.contentId,
        "aria-labelledby": l.triggerId,
        ...r,
        ref: M,
        align: "start",
        side: d.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          d.isUsingKeyboardRef.current && m.current?.focus(), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: v(e.onFocusOutside, (p) => {
          p.target !== l.trigger && c.onOpenChange(!1);
        }),
        onEscapeKeyDown: v(e.onEscapeKeyDown, (p) => {
          d.onClose(), p.preventDefault();
        }),
        onKeyDown: v(e.onKeyDown, (p) => {
          const u = p.currentTarget.contains(p.target), f = bn[d.dir].includes(p.key);
          u && f && (c.onOpenChange(!1), l.trigger?.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
Ue.displayName = Ke;
function $e(e) {
  return e ? "open" : "closed";
}
function V(e) {
  return e === "indeterminate";
}
function ae(e) {
  return V(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Hn(e) {
  const o = document.activeElement;
  for (const n of e)
    if (n === o || (n.focus(), document.activeElement !== o)) return;
}
function Wn(e, o) {
  return e.map((n, t) => e[(o + t) % e.length]);
}
function zn(e, o, n) {
  const r = o.length > 1 && Array.from(o).every((M) => M === o[0]) ? o[0] : o, c = n ? e.indexOf(n) : -1;
  let d = Wn(e, Math.max(c, 0));
  r.length === 1 && (d = d.filter((M) => M !== n));
  const m = d.find(
    (M) => M.toLowerCase().startsWith(r.toLowerCase())
  );
  return m !== n ? m : void 0;
}
function Zn(e, o) {
  const { x: n, y: t } = e;
  let r = !1;
  for (let c = 0, d = o.length - 1; c < o.length; d = c++) {
    const l = o[c], m = o[d], M = l.x, p = l.y, u = m.x, f = m.y;
    p > t != f > t && n < (u - M) * (t - p) / (f - p) + M && (r = !r);
  }
  return r;
}
function qn(e, o) {
  if (!o) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Zn(n, o);
}
function k(e) {
  return (o) => o.pointerType === "mouse" ? e(o) : void 0;
}
var Jn = Re, Qn = Q, eo = Pe, no = Ee, oo = te, to = Ie, ro = j, ao = Se, co = xe, so = Ae, uo = Oe, io = ke, lo = Le, po = Ge, fo = Ue, H = "DropdownMenu", [mo, tt] = fe(
  H,
  [_e]
), w = _e(), [Mo, Be] = mo(H), Ve = (e) => {
  const {
    __scopeDropdownMenu: o,
    children: n,
    dir: t,
    open: r,
    defaultOpen: c,
    onOpenChange: d,
    modal: l = !0
  } = e, m = w(o), M = a.useRef(null), [p, u] = cn({
    prop: r,
    defaultProp: c ?? !1,
    onChange: d,
    caller: H
  });
  return /* @__PURE__ */ s(
    Mo,
    {
      scope: o,
      triggerId: le(),
      triggerRef: M,
      contentId: le(),
      open: p,
      onOpenChange: u,
      onOpenToggle: a.useCallback(() => u((f) => !f), [u]),
      modal: l,
      children: /* @__PURE__ */ s(Jn, { ...m, open: p, onOpenChange: u, dir: t, modal: l, children: n })
    }
  );
};
Ve.displayName = H;
var Xe = "DropdownMenuTrigger", Ye = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, disabled: t = !1, ...r } = e, c = Be(Xe, n), d = w(n);
    return /* @__PURE__ */ s(Qn, { asChild: !0, ...d, children: /* @__PURE__ */ s(
      y.button,
      {
        type: "button",
        id: c.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": c.open,
        "aria-controls": c.open ? c.contentId : void 0,
        "data-state": c.open ? "open" : "closed",
        "data-disabled": t ? "" : void 0,
        disabled: t,
        ...r,
        ref: me(o, c.triggerRef),
        onPointerDown: v(e.onPointerDown, (l) => {
          !t && l.button === 0 && l.ctrlKey === !1 && (c.onOpenToggle(), c.open || l.preventDefault());
        }),
        onKeyDown: v(e.onKeyDown, (l) => {
          t || (["Enter", " "].includes(l.key) && c.onOpenToggle(), l.key === "ArrowDown" && c.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(l.key) && l.preventDefault());
        })
      }
    ) });
  }
);
Ye.displayName = Xe;
var vo = "DropdownMenuPortal", je = (e) => {
  const { __scopeDropdownMenu: o, ...n } = e, t = w(o);
  return /* @__PURE__ */ s(eo, { ...t, ...n });
};
je.displayName = vo;
var He = "DropdownMenuContent", We = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = Be(He, n), c = w(n), d = a.useRef(!1);
    return /* @__PURE__ */ s(
      no,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...c,
        ...t,
        ref: o,
        onCloseAutoFocus: v(e.onCloseAutoFocus, (l) => {
          d.current || r.triggerRef.current?.focus(), d.current = !1, l.preventDefault();
        }),
        onInteractOutside: v(e.onInteractOutside, (l) => {
          const m = l.detail.originalEvent, M = m.button === 0 && m.ctrlKey === !0, p = m.button === 2 || M;
          (!r.modal || p) && (d.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
We.displayName = He;
var go = "DropdownMenuGroup", wo = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ s(oo, { ...r, ...t, ref: o });
  }
);
wo.displayName = go;
var ho = "DropdownMenuLabel", _o = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ s(to, { ...r, ...t, ref: o });
  }
);
_o.displayName = ho;
var Co = "DropdownMenuItem", ze = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ s(ro, { ...r, ...t, ref: o });
  }
);
ze.displayName = Co;
var Ro = "DropdownMenuCheckboxItem", Do = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(ao, { ...r, ...t, ref: o });
});
Do.displayName = Ro;
var Po = "DropdownMenuRadioGroup", Eo = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(co, { ...r, ...t, ref: o });
});
Eo.displayName = Po;
var Io = "DropdownMenuRadioItem", bo = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(so, { ...r, ...t, ref: o });
});
bo.displayName = Io;
var So = "DropdownMenuItemIndicator", yo = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(uo, { ...r, ...t, ref: o });
});
yo.displayName = So;
var xo = "DropdownMenuSeparator", No = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(io, { ...r, ...t, ref: o });
});
No.displayName = xo;
var Ao = "DropdownMenuArrow", To = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
    return /* @__PURE__ */ s(lo, { ...r, ...t, ref: o });
  }
);
To.displayName = Ao;
var Oo = "DropdownMenuSubTrigger", ko = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(po, { ...r, ...t, ref: o });
});
ko.displayName = Oo;
var Lo = "DropdownMenuSubContent", Fo = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = w(n);
  return /* @__PURE__ */ s(
    fo,
    {
      ...r,
      ...t,
      ref: o,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Fo.displayName = Lo;
var Go = Ve, Ko = Ye, Uo = je, Ze = We, qe = ze;
const rt = Go, at = Ko, $o = a.forwardRef(({ className: e, sideOffset: o = 4, ...n }, t) => /* @__PURE__ */ s(Uo, { children: /* @__PURE__ */ s(
  Ze,
  {
    ref: t,
    sideOffset: o,
    className: we(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border",
      "bg-[var(--background)]/95 backdrop-blur supports-[backdrop-filter]:bg-[var(--background)]/85",
      "p-1 text-[var(--foreground)] shadow-lg",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
$o.displayName = Ze.displayName;
const Bo = a.forwardRef(({ className: e, ...o }, n) => /* @__PURE__ */ s(
  qe,
  {
    ref: n,
    className: we(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-[var(--accent)] hover:text-[var(--accent-foreground)] focus:bg-[var(--accent)] focus:text-[var(--accent-foreground)] data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...o
  }
));
Bo.displayName = qe.displayName;
export {
  rt as DropdownMenu,
  $o as DropdownMenuContent,
  Bo as DropdownMenuItem,
  at as DropdownMenuTrigger
};
//# sourceMappingURL=dropdown-menu.js.map
